// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1Scyc","location":"Header_location__xSBJw"};